<template>
  <div
    class="footer-mini pt-0 pt-md-0 pt-lg-0 pb-0 pb-md-2 pb-lg-2 footer-bg"
    :class="[this.IsChangefooter, this.IspageName]"
  >
    <hr style="border-top: 1px solid #505f74" />

    <div class="container hk-container-padding">
      <div class="pb-4 pt-0 pt-md-4 pt-lg-4 row">
        <div
          class="col-12 col-sm-12 col-md-12 col-lg-12 text-center d-block my-auto"
        >
          <ul class="list-inline mb-0">
            <li class="list-inline-item hk-cursor-pointer">
              <router-link :to="'/privacypolicy'" target="_blank">{{
                $t("footer.hk_privacy_policy")
              }}</router-link>
            </li>
            <!-- <li class="list-inline-item">|</li>
                    <li class="list-inline-item hk-cursor-pointer">
                        <div data-bs-toggle="modal" data-bs-target="#trust">{{$t('footer.hk_terms_conditions')}}</div>
                    </li> -->

            <li class="list-inline-item">|</li>
            <li class="list-inline-item hk-cursor-pointer">
              <router-link :to="'/terms&conditions'" target="_blank"
                >Terms & Conditions</router-link
              >
            </li>
            <li class="list-inline-item">|</li>
            <li class="list-inline-item hk-cursor-pointer">
              <router-link :to="'/isms-policy'" target="_blank">{{
                $t("footer.hk_isms_policy")
              }}</router-link>
            </li>
            <li class="list-inline-item">|</li>
            <li class="list-inline-item hk-cursor-pointer">
              <router-link :to="'/privacy-objectives'" target="_blank"
                >Privacy Objectives</router-link
              >
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- cookies -->
    <div class="cookies-bg" v-if="this.cookiesDialogVisible">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="cookies-header">
              <div class="cookies-content">
                <p class="cookies-main-text">
                  {{ $t("footer.cookies_text_main") }}
                  <router-link
                    to="/privacypolicy#section18"
                    class="cookies-policy-link"
                    target="_blank"
                    >{{ $t("footer.cookies_policy_link") }}</router-link
                  >
                </p>
                <p class="cookies-detail-text">
                  {{ $t("footer.cookies_detail_text") }}
                </p>
              </div>
              <div class="cookies-buttons">
                <button
                  class="btn hk-btn-cookies-accept"
                  @click="acceptCookies()"
                >
                  {{ $t("all_hk_btn.btn_accept_all") }}
                </button>
                <button
                  class="btn hk-btn-cookies-decline"
                  @click="declineCookies()"
                >
                  {{ $t("all_hk_btn.btn_decline_all") }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- support button  -->
<div class="position-fixed end-0 p-5" style="z-index: 111; bottom: 20px !important;">
  <router-link :to="'/support'" class="nav-link p-0">
    <div class="support-button-wrapper">
      <div class="support-icon-circle">
        <img src="@/assets/common/support-agent-icon-2.svg" alt="support" class="demo-svg" />
      </div>
      <span class="support-text">Contact Support</span>
    </div>
  </router-link>
</div>

    <!-- duplicate toast on left (keeps original right toast unchanged) -->
    <div class="position-fixed bottom-0 start-0 p-3" style="z-index: 111">
      <div
        id="liveToastRight"
        class="toast"
        :class="showToastRight ? 'show' : 'hide'"
      >
        <div class="toast-header">
          <strong class="me-auto toast-color">{{
            $t("footer.right_side_heading")
          }}</strong>
          <button
            @click="clostToastRight()"
            type="button"
            class="btn-close"
            data-bs-dismiss="toast"
            aria-label="Close"
          ></button>
        </div>
        <div class="toast-body">
          <p class="mb-0 toast-color">
            {{ $t("footer.right_side_popup_text") }}
          </p>
          <button class="btn hk-btn-toast" @click="goToContact()">
            {{ $t("all_hk_btn.btn_contact_team") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  components: {},
  name: "FooterMini",
  data() {
    return {
      cookiesDialogVisible: false,
      showToast: true,
      showToastRight: false,
      IsChangefooter: "",
      images: [
        require("@/assets/expert-review/expidia.png"),
        require("@/assets/expert-review/expidia.png"),
        require("@/assets/expert-review/expidia.png"),
        require("@/assets/expert-review/expidia.png"),
        require("@/assets/expert-review/expidia.png"),
        require("@/assets/expert-review/expidia.png"),
        require("@/assets/expert-review/expidia.png"),
        require("@/assets/expert-review/expidia.png"),
        require("@/assets/expert-review/expidia.png"),
        require("@/assets/expert-review/expidia.png"),
      ],
    };
  },
  computed: {
    //     IsChangefooter() {
    //     return this.$i18n.locale;
    // },
    IspageName() {
      return this.$route.name;
    },
  },
  beforeMount() {
    if (sessionStorage.getItem("restrictionPopup") == null) {
      this.cookiesDialogVisible = true;
    }
    if (sessionStorage.getItem("toastPopup") == null) {
      setTimeout(() => {
        this.showToastRight = true;
      }, 45000);
    }
  },
  mounted() {},

  methods: {
    acceptCookies() {
      if (sessionStorage.getItem("restrictionPopup") == null) {
        this.cookiesDialogVisible = false;
        sessionStorage.setItem("restrictionPopup", "true");
        sessionStorage.setItem("cookiesConsent", "accepted");

        window.dataLayer = window.dataLayer || [];

        function gtag() {
          dataLayer.push(arguments);
        }
        gtag("js", new Date());
        gtag("config", "G-5NFP1NE0L9");
        // old - G-Z32VVYFV0J
      }
    },
    declineCookies() {
      if (sessionStorage.getItem("restrictionPopup") == null) {
        this.cookiesDialogVisible = false;
        sessionStorage.setItem("restrictionPopup", "true");
        sessionStorage.setItem("cookiesConsent", "declined");
        // Do not load analytics or tracking scripts when declined
      }
    },
    checkRestrickt() {
      // Legacy method - keeping for compatibility
      this.acceptCookies();
    },
    goToContact() {
      if (sessionStorage.getItem("toastPopup") == null) {
        this.$router.push({ path: "contact-team" });
        sessionStorage.setItem("toastPopup", "true");
      }
    },
    clostToast() {
      sessionStorage.setItem("toastPopup", "true");
    },
    // Right-side duplicate handlers
    clostToastRight() {
      this.showToastRight = false;
      sessionStorage.setItem("toastPopup", "true");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/sass/config/variables.scss";
@import "@/assets/sass/main.scss";

.support-button-wrapper {
  display: flex;
  align-items: center;
  background-color: #ffffff; // Default theme color
  border: 2px solid #1b95cd;
  border-radius: 50px; // Keeps it rounded
  padding: 5px;
  overflow: hidden;
  max-width: 50px; // Initially just the icon
  height: 50px;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  cursor: pointer;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);

  .support-icon-circle {
    min-width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.4s ease;

    img {
      width: 28px;
      height: 28px;
    }
  }

  .support-text {
    color: #1b95cd;
    font-weight: 600;
    font-size: 14px;
    white-space: nowrap;
    opacity: 0;
    margin-left: 0;
    transition: opacity 0.3s ease, margin 0.3s ease;
  }

  // Hover States
  &:hover {
    max-width: 200px; // Expands to show text
    background-color: #ffffff; // Changes to white bg
    padding: 5px 20px 5px 10px;
    
    .support-text {
      opacity: 1;
      margin-left: 10px;
    }
  }
}

// Keep the floating animation from before but apply it to the wrapper
.support-button-wrapper {
  animation: float-support 3s ease-in-out infinite;
}

@keyframes float-support {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-8px); }
}
.footer-mini {
  background: #fff;
}

.footer-mini.IotKey {
  background: #f5f9f8;
}

.footer-mini.IT.HomePage {
  background: #fcf9f6;
}

.footer-mini.TH.HomePage {
  background: #f1f0f4;
}

.footer-mini.ES.HomePage {
  background: #faf7ef;
}

.footer-mini.DE.HomePage {
  backgrgetuseound: #fffdf9;
}

.footer-mini.FR.HomePage {
  background: #f7f8fb;
}

.footer-mini.africa.HomePage {
  background: #f1f2e6e6;
}

.footer-mini {
  position: relative;
  margin-top: -1rem;

  .list-inline {
    .list-inline-item {
      color: $p-color;
      font-size: 14px;

      a {
        color: $p-color;
        font-size: 14px;
        cursor: pointer;
      }
    }
  }
}

.hand {
  width: 26px;
}

.toast-color {
  color: $main-headings;
}

.toast-header {
  font-size: 18px;
}

.hk-btn-toast {
  background: $hk-blue !important;
  color: #ffffff !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  padding: 8px !important;
  line-height: unset !important;
  letter-spacing: unset !important;
  margin-top: 5px;
}

#liveToast {
  border: unset;
  background: #fff;
}

.btn-close {
  background: transparent url("@/assets/logo/cross.svg") center/2em auto
    no-repeat;
  font-size: 14px;
}

.toast-body {
  .toast-color {
    font-size: 16px;
  }
}

.toast {
  --bs-toast-max-width: 300px;
}

.list-inline-item:not(:last-child) {
  margin-right: 0.75rem;
}

.list-inline-item.text-white a {
  opacity: 1;
}

.list-inline-item.hk-list-inline-item a {
  opacity: 1;
}

.privacy-policy {
  h3 {
    font-size: 18px;
    font-weight: 700;
  }

  .modal-header {
    border-bottom: unset;

    .hk-btn-close {
      padding: 0;
      cursor: pointer;

      img {
        width: 40px;
      }
    }
  }

  .modal-body {
    max-height: 500px;
    overflow-y: auto;
  }

  .modal-content {
    padding: 0 2rem;
  }

  ul {
    li {
      list-style-type: none;
    }
  }
}

.modal-dialog {
  p {
    color: $main-headings;
  }
}

.cookies-bg {
  width: 100%;
  background: #323232;
  // background: #323232ed;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 111;

  .cookies-header {
    display: flex;
    padding: 1.5rem 0rem;
    align-items: center;
    justify-content: space-between;
    gap: 2rem;

    .cookies-content {
      flex: 1;
      text-align: left;

      .cookies-main-text {
        font-size: 1rem;
        color: $white;
        margin-bottom: 0.5rem;
        font-weight: 500;

        .cookies-policy-link {
          color: #6cc2b6;
          text-decoration: underline;
          font-weight: 600;

          &:hover {
            color: #7fd4c8;
          }
        }
      }

      .cookies-detail-text {
        font-size: 0.875rem;
        color: #e0e0e0;
        margin-bottom: 0rem;
        line-height: 1.5;
      }
    }

    .cookies-buttons {
      display: flex;
      gap: 1rem;
      flex-shrink: 0;

      .hk-btn-cookies-accept {
        background: #196155;
        color: $white;
        font-size: 1rem;
        border-radius: 20px;
        font-weight: 600;
        padding: 0.5rem 1.5rem;
        white-space: nowrap;

        &:hover {
          background: #259384;
        }
      }

      .hk-btn-cookies-decline {
        background: transparent;
        border: 2px solid #6cc2b6;
        color: #6cc2b6;
        font-size: 1rem;
        border-radius: 20px;
        font-weight: 600;
        padding: 0.5rem 1.5rem;
        white-space: nowrap;

        &:hover {
          background: #6cc2b6;
          color: #323232;
        }
      }
    }
  }
}

.modal-title {
  font-weight: 700;
}

.btn-close:focus {
  box-shadow: unset !important;
}

@media (max-width: 575.98px) {
  .cookies-bg .cookies-header {
    flex-direction: column !important;
    align-items: flex-start !important;
    gap: 1rem !important;

    .cookies-content {
      .cookies-main-text {
        font-size: 0.875rem;
      }

      .cookies-detail-text {
        font-size: 0.75rem;
      }
    }

    .cookies-buttons {
      width: 100%;
      flex-direction: column;

      button {
        width: 100%;
      }
    }
  }

  .footer-mini .list-inline .list-inline-item {
    font-size: 12px;
  }

  .footer-mini .list-inline .list-inline-item a {
    font-size: 12px;
  }

  .footer-mini {
    padding-left: 5px;
    padding-right: 5px;
  }

  .m-fw-600 {
    font-weight: 600;
  }

  // Mobile support button styles
  .position-fixed.end-0.p-5 {
    padding: 1rem !important;
    bottom: 10px !important;
  }

  .support-button-wrapper {
    max-width: 50px !important;
    height: 50px !important;
    padding: 5px !important;

    .support-icon-circle {
      min-width: 38px;
      height: 38px;

      img {
        width: 30px;
        height: 30px;
      }
    }

    .support-text {
      display: none !important; // Hide text on mobile by default
    }

    // On mobile, show text when tapped/touched
    &:active {
      max-width: 180px !important;
      padding: 5px 15px 5px 8px !important;

      .support-text {
        display: block !important;
        opacity: 1 !important;
        margin-left: 8px !important;
      }
    }
  }

  // Adjust toast position on mobile
  .position-fixed.bottom-0.start-0 {
    padding: 0.5rem !important;
  }
}
</style>
